module.exports = __webpack_public_path__ + "img/triangle-fill.863e9e12.svg";